import React from "react";
import { Copy, Download } from "lucide-react";
import { toast } from "sonner";

const API = process.env.REACT_APP_BACKEND_URL;

// Gym partners: three ready-made Instagram stories with their own link and code, plus a caption for each.
export const StarterKit = ({ kit, gold, cream, dim, serif, sans }) => {
  const copy = (t) => navigator.clipboard?.writeText(t).then(() => toast.success("Caption copied")).catch(() => toast.error("Couldn't copy"));
  return (
    <div className="mt-12" data-testid="influencer-starter-kit">
      <p className="text-[0.6rem] uppercase tracking-[0.28em]" style={{ color: gold, fontFamily: sans }}>Your starter kit</p>
      <h2 className="mt-2 text-3xl font-light" style={{ fontFamily: serif, color: cream }}>Three stories and feed posts, ready to share.</h2>
      <p className="mt-2 text-sm" style={{ color: dim, fontFamily: sans }}>Each one already has your link and code. Save a story or square feed post, copy the caption, and share it.</p>
      <div className="mt-6 grid grid-cols-1 gap-6 sm:grid-cols-3">
        {kit.map((k, i) => (
          <div key={k.image_url} className="flex flex-col" data-testid={`starter-kit-item-${i}`}>
            <img src={`${API}${k.image_url}`} alt={`Story design ${i + 1}`} loading="lazy" className="aspect-[9/16] w-full rounded-2xl object-cover" style={{ border: `1px solid ${gold}33` }} />
            <p className="mt-3 flex-1 text-xs leading-relaxed" style={{ color: dim, fontFamily: sans }} data-testid={`starter-kit-caption-${i}`}>{k.caption}</p>
            <div className="mt-3 flex gap-2">
              <a href={`${API}${k.image_url}?download=true`} download data-testid={`starter-kit-download-${i}`}
                className="inline-flex flex-1 items-center justify-center gap-1.5 rounded-full py-2 text-[0.65rem] uppercase tracking-[0.2em] transition-opacity hover:opacity-90" style={{ background: gold, color: "#0b1220", fontFamily: sans }}>
                <Download size={13} /> Save image
              </a>
              <button type="button" onClick={() => copy(k.caption)} data-testid={`starter-kit-copy-${i}`}
                className="inline-flex flex-1 items-center justify-center gap-1.5 rounded-full py-2 text-[0.65rem] uppercase tracking-[0.2em] transition-colors hover:bg-white/5" style={{ border: `1px solid ${gold}`, color: cream, fontFamily: sans }}>
                <Copy size={13} /> Caption
              </button>
            </div>
            <a href={`${API}${k.square_url}&download=true`} download data-testid={`starter-kit-square-${i}`}
              className="mt-2 inline-flex items-center justify-center gap-1.5 rounded-full py-2 text-[0.65rem] uppercase tracking-[0.2em] transition-colors hover:bg-white/5" style={{ border: `1px solid ${gold}55`, color: dim, fontFamily: sans }}>
              <Download size={13} /> Square feed post
            </a>
          </div>
        ))}
      </div>
    </div>
  );
};
